(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["srs-main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SRSCollection) return;
  window.SRSCollection = true;

  var COLS_KEY = 'srs-collection-cols';

  /* ---- Hidden helper products: load-more from a deferred <template> and exact counts ---- */
  function deferred(r) {
    var grid = r.querySelector('[data-srs-grid]');
    if (!grid) return null;
    var tpl = grid.querySelector(':scope > template[data-srs-deferred]');
    if (!tpl) {
      tpl = document.createElement('template');
      tpl.setAttribute('data-srs-deferred', '');
      grid.appendChild(tpl);
    }
    return tpl;
  }

  function updateMore(r) {
    var more = r.querySelector('[data-srs-more]');
    var grid = r.querySelector('[data-srs-grid]');
    if (!more || !grid) return;
    var tpl = deferred(r);
    var shown = grid.querySelectorAll(':scope > [data-srs-card]').length;
    var waiting = tpl.content.querySelectorAll('[data-srs-card]').length;
    var loading = !!more._srsLoading;
    var total = shown + waiting;
    if (loading) total = Math.max(total, parseInt(more.getAttribute('data-total'), 10) || total);
    var s = more.querySelector('[data-srs-shown]'); if (s) s.textContent = shown;
    var tt = more.querySelector('[data-srs-total]'); if (tt) tt.textContent = total;
    var bar = more.querySelector('[data-srs-bar]');
    if (bar) bar.style.width = (total ? Math.min(100, Math.round(shown * 100 / total)) : 100) + '%';
    var btn = more.querySelector('[data-srs-load-more]');
    if (btn) btn.hidden = !(waiting > 0 || loading);
    more.hidden = total === 0 && !loading;
    more.classList.toggle('is-counting', loading);
    if (!loading) {
      var cnt = r.querySelector('[data-srs-count]'); if (cnt) cnt.removeAttribute('data-srs-approx');
      var c = r.querySelector('[data-srs-count] b'); if (c) c.textContent = total;
      var none = r.querySelector('[data-srs-none]'); if (none) none.hidden = total !== 0 || !!r.querySelector('[data-srs-grid] .srs-empty');
    }
  }

  function reveal(r) {
    var grid = r.querySelector('[data-srs-grid]');
    var tpl = deferred(r);
    if (!grid || !tpl) return 0;
    var more = r.querySelector('[data-srs-more]');
    var per = more ? (parseInt(more.getAttribute('data-per'), 10) || 24) : 24;
    var moved = 0;
    while (tpl.content.firstChild && moved < per) {
      var n = tpl.content.firstChild;
      if (n.nodeType === 1 && n.hasAttribute('data-srs-card')) moved++;
      grid.insertBefore(document.importNode(n, true), tpl);
      tpl.content.removeChild(n);
    }
    applySearch(r);
    updateMore(r);
    return moved;
  }

  function prepare(r) {
    var more = r.querySelector('[data-srs-more]');
    var grid = r.querySelector('[data-srs-grid]');
    if (!more || !grid) return;
    var next = more.getAttribute('data-next');
    if (!next) { updateMore(r); return; }
    more.removeAttribute('data-next');
    more._srsLoading = true;
    updateMore(r);
    var token = {};
    r._srsToken = token;
    var id = r.getAttribute('data-section-id');
    (function step(url) {
      fetch(withSection(url, id))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          if (r._srsToken !== token) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tpl = deferred(r);
          var g = doc.querySelector('[data-srs-grid]');
          if (g) {
            g.querySelectorAll(':scope > [data-srs-card]').forEach(function (c) { tpl.content.appendChild(document.importNode(c, true)); });
            var t2 = g.querySelector(':scope > template[data-srs-deferred]');
            if (t2) t2.content.querySelectorAll('[data-srs-card]').forEach(function (c) { tpl.content.appendChild(document.importNode(c, true)); });
          }
          var fm = doc.querySelector('[data-srs-more]');
          var n = fm && fm.getAttribute('data-next');
          if (n) { step(n); return; }
          more._srsLoading = false;
          if (!grid.querySelector(':scope > [data-srs-card]')) reveal(r); else updateMore(r);
        })
        .catch(function () { more._srsLoading = false; updateMore(r); });
    })(next);
  }

  function root(el) { return el && el.closest ? el.closest('[data-srs]') : null; }

  function toast(r, msg, isError) {
    var t = r && r.querySelector('[data-srs-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  function withSection(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function applyDensity(r) {
    var cols = null;
    try { cols = window.localStorage.getItem(COLS_KEY); } catch (e) {}
    var grid = r.querySelector('[data-srs-grid]');
    if (cols && grid) grid.style.setProperty('--srs-cols', cols);
    var current = cols || getComputedStyle(r).getPropertyValue('--srs-cols').trim();
    r.querySelectorAll('[data-srs-density] button').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-cols') === current);
    });
  }

  function applySearch(r) {
    var input = r.querySelector('[data-srs-search]');
    var empty = r.querySelector('[data-srs-search-empty]');
    if (!input) return;
    var term = input.value.trim().toLowerCase();
    var visible = 0;
    r.querySelectorAll('[data-srs-grid] > *').forEach(function (el) {
      if (el.hasAttribute('data-srs-card')) {
        var match = !term || (el.getAttribute('data-search') || '').indexOf(term) > -1;
        el.hidden = !match;
        if (match) visible++;
      } else if (!el.classList.contains('srs-empty')) {
        el.hidden = !!term;
      }
    });
    if (empty) {
      empty.hidden = !term || visible > 0;
      var t = empty.querySelector('[data-srs-term]');
      if (t) t.textContent = input.value.trim();
      var all = empty.querySelector('[data-srs-search-all]');
      if (all) all.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?type=product&q=' + encodeURIComponent(input.value.trim());
    }
  }

  function render(r, url, push) {
    var id = r.getAttribute('data-section-id');
    r.classList.add('is-loading');
    return fetch(withSection(url, id))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-srs]');
        if (!fresh) return;
        ['[data-srs-filters]', '[data-srs-results]'].forEach(function (sel) {
          var a = r.querySelector(sel), b = fresh.querySelector(sel);
          if (a && b) a.replaceWith(b);
        });
        if (push !== false) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          clean.searchParams.delete('page');
          window.history.replaceState({}, '', clean.pathname + clean.search);
        }
        applyDensity(r);
        prepare(r);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { r.classList.remove('is-loading'); });
  }

  function formUrl(r) {
    var form = r.querySelector('[data-srs-form]');
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    return window.location.pathname + '?' + params.toString();
  }

  var debounce;
  document.addEventListener('change', function (e) {
    var r = root(e.target);
    if (!r) return;
    if (e.target.closest('[data-srs-form]')) {
      clearTimeout(debounce);
      debounce = setTimeout(function () { render(r, formUrl(r)); }, e.target.type === 'number' ? 600 : 0);
    } else if (e.target.matches('[data-srs-sort]')) {
      var hidden = r.querySelector('[data-srs-sort-hidden]');
      if (hidden) hidden.value = e.target.value;
      render(r, formUrl(r));
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-srs-search]')) return;
    applySearch(root(e.target));
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var r = root(t);
    if (!r) return;

    var tagA = t.closest('.srs-taglink a, .srs-active a.srs-pill');
    if (tagA) { e.preventDefault(); r.classList.remove('is-drawer-open'); render(r, tagA.href); return; }

    var link = t.closest('[data-srs-url]');
    if (link) { e.preventDefault(); render(r, link.href); return; }

    var more = t.closest('[data-srs-load-more]');
    if (more) {
      e.preventDefault();
      var tplNow = deferred(r);
      if (tplNow && tplNow.content.querySelector('[data-srs-card]')) { reveal(r); return; }
      var box = r.querySelector('[data-srs-more]');
      if (box && box._srsLoading && !more.classList.contains('is-busy')) {
        more.classList.add('is-busy');
        var label = more.textContent;
        more.textContent = 'Loading…';
        var wait = setInterval(function () {
          if (box._srsLoading) return;
          clearInterval(wait);
          more.textContent = label;
          more.classList.remove('is-busy');
          reveal(r);
        }, 150);
      }
      return;
    }

    var dens = t.closest('[data-srs-density] button');
    if (dens) {
      var cols = dens.getAttribute('data-cols');
      try { window.localStorage.setItem(COLS_KEY, cols); } catch (err) {}
      applyDensity(r);
      return;
    }

    if (t.closest('[data-srs-drawer-open]')) { r.classList.add('is-drawer-open'); return; }
    if (t.closest('[data-srs-drawer-close]')) { r.classList.remove('is-drawer-open'); return; }

    var clipBtn = t.closest('[data-srs-clip-toggle]');
    if (clipBtn) {
      var clip = r.querySelector('[data-srs-clip]');
      clip.classList.toggle('is-open');
      clipBtn.textContent = clip.classList.contains('is-open') ? 'Read less' : 'Read more';
      return;
    }

    var card = t.closest('[data-srs-card]');
    if (!card) return;

    var qaToggle = t.closest('[data-srs-qa-toggle]');
    if (qaToggle) {
      r.querySelectorAll('[data-srs-card].is-qa-open').forEach(function (c) { if (c !== card) c.classList.remove('is-qa-open'); });
      card.classList.toggle('is-qa-open');
      qaToggle.textContent = card.classList.contains('is-qa-open') ? '×' : '+';
      return;
    }

    var sib = t.closest('[data-srs-sibling]');
    if (sib) {
      e.preventDefault();
      var url = new URL(sib.getAttribute('data-srs-sibling'), window.location.origin);
      url.searchParams.set('view', 'srs-card');
      card.style.opacity = '.6';
      fetch(url.toString())
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-srs-card]');
          if (fresh) card.replaceWith(fresh); else window.location.href = sib.getAttribute('data-srs-sibling');
        })
        .catch(function () { window.location.href = sib.getAttribute('data-srs-sibling'); });
      return;
    }

    var color = t.closest('[data-srs-color]');
    if (color) {
      e.preventDefault();
      var name = color.getAttribute('data-srs-color');
      card.querySelectorAll('[data-srs-color]').forEach(function (s) { s.classList.toggle('is-active', s === color); });
      var img = card.querySelector('[data-srs-primary]');
      var src = color.getAttribute('data-image');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      var vurl = color.getAttribute('data-variant-url');
      if (vurl) card.querySelectorAll('a[href]').forEach(function (a) { if (a.closest('[data-srs-qa]') || a.matches('.srs-card__link, .srs-card__title')) a.href = vurl; });
      card.querySelectorAll('.srs-qa__chip').forEach(function (chip) { chip.hidden = chip.getAttribute('data-color') !== name; });
      return;
    }

    var add = t.closest('[data-srs-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      var original = add.innerHTML;
      add.disabled = true;
      var root_url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-variant-id')), quantity: 1 }] })
      })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function (data) {
          add.classList.add('is-added');
          add.innerHTML = '✓';
          var item = data.items ? data.items[0] : data;
          document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: item }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
          fetch(root_url + 'cart.js').then(function (res) { return res.json(); }).then(function (cart) {
            document.querySelectorAll('[data-header-cart-count], [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
          toast(r, 'Added to cart — ' + (item.product_title || '') + (item.variant_title ? ' / ' + item.variant_title : ''));
        })
        .catch(function (err) {
          toast(r, (err && (err.description || err.message)) || 'Could not add to cart', true);
        })
        .finally(function () {
          setTimeout(function () { add.classList.remove('is-added'); add.innerHTML = original; add.disabled = false; }, 1400);
        });
    }
  });

  function init() { document.querySelectorAll('[data-srs]').forEach(function (r) { applyDensity(r); prepare(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
